// Texts of the project area (GIOTHUB-185): the live project page, the
// /demo page's own messages and the online manual's viewer. English
// defines the keys.
import type { Dict } from "./dict";

const en = {
  "proj.demo.reply": "This is the demo: the AI answers in a real project.",
  "proj.demo.file": "({path}: shown in a real project)",
  "proj.demo.comment": "(the field's comment in the .proto)",
  "proj.help.title": "Help",
  "proj.help.doctitle": "{title} - Type Builder help",
  "proj.help.search": "Search the manual",
  "proj.help.theme": "Switch light or dark",
  "proj.help.open": "Open the builder",
  "proj.help.chapters": "Chapters",
  "proj.help.manual": "User manual",
  "proj.help.try": "Try it",
  "proj.help.demo": "Demo workbench",
  "proj.help.searchfor": "Search: {q}",
  "proj.help.nothing": "Nothing found.",
  "proj.help.onpage": "On this page",
  "proj.help.vocab.error": "The vocabulary could not be loaded ({error}).",
  "proj.help.vocab.loading": "Loading the vocabulary…",
} as const;

const de = {
  "proj.demo.reply": "Dies ist die Demo: In einem echten Projekt antwortet die KI.",
  "proj.demo.file": "({path}: wird in einem echten Projekt angezeigt)",
  "proj.demo.comment": "(der Kommentar des Felds in der .proto)",
  "proj.help.title": "Hilfe",
  "proj.help.doctitle": "{title} - Type Builder Hilfe",
  "proj.help.search": "Handbuch durchsuchen",
  "proj.help.theme": "Hell oder dunkel",
  "proj.help.open": "Builder öffnen",
  "proj.help.chapters": "Kapitel",
  "proj.help.manual": "Benutzerhandbuch",
  "proj.help.try": "Ausprobieren",
  "proj.help.demo": "Demo-Arbeitsbereich",
  "proj.help.searchfor": "Suche: {q}",
  "proj.help.nothing": "Nichts gefunden.",
  "proj.help.onpage": "Auf dieser Seite",
  "proj.help.vocab.error": "Das Vokabular konnte nicht geladen werden ({error}).",
  "proj.help.vocab.loading": "Vokabular wird geladen…",
} satisfies Dict<typeof en>;

const it = {
  "proj.demo.reply": "Questa è la demo: in un progetto reale risponde l'IA.",
  "proj.demo.file": "({path}: visualizzato in un progetto reale)",
  "proj.demo.comment": "(il commento del campo nel .proto)",
  "proj.help.title": "Aiuto",
  "proj.help.doctitle": "{title} - Aiuto di Type Builder",
  "proj.help.search": "Cerca nel manuale",
  "proj.help.theme": "Tema chiaro o scuro",
  "proj.help.open": "Apri il builder",
  "proj.help.chapters": "Capitoli",
  "proj.help.manual": "Manuale utente",
  "proj.help.try": "Provalo",
  "proj.help.demo": "Area di lavoro demo",
  "proj.help.searchfor": "Ricerca: {q}",
  "proj.help.nothing": "Nessun risultato.",
  "proj.help.onpage": "In questa pagina",
  "proj.help.vocab.error": "Impossibile caricare il vocabolario ({error}).",
  "proj.help.vocab.loading": "Caricamento del vocabolario…",
} satisfies Dict<typeof en>;

const fr = {
  "proj.demo.reply": "Ceci est la démo : dans un vrai projet, l'IA répond.",
  "proj.demo.file": "({path} : affiché dans un vrai projet)",
  "proj.demo.comment": "(le commentaire du champ dans le .proto)",
  "proj.help.title": "Aide",
  "proj.help.doctitle": "{title} - Aide de Type Builder",
  "proj.help.search": "Rechercher dans le manuel",
  "proj.help.theme": "Thème clair ou sombre",
  "proj.help.open": "Ouvrir le builder",
  "proj.help.chapters": "Chapitres",
  "proj.help.manual": "Manuel d'utilisation",
  "proj.help.try": "Essayer",
  "proj.help.demo": "Espace de travail de démo",
  "proj.help.searchfor": "Recherche : {q}",
  "proj.help.nothing": "Aucun résultat.",
  "proj.help.onpage": "Sur cette page",
  "proj.help.vocab.error": "Le vocabulaire n'a pas pu être chargé ({error}).",
  "proj.help.vocab.loading": "Chargement du vocabulaire…",
} satisfies Dict<typeof en>;

export default { en, de, it, fr };
